import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../ReduxToolkit/Hooks';
import { setCreatedData } from '../../../../ReduxToolkit/Reducers/ProjectSlice';
import { Form, Formik, ErrorMessage, Field } from 'formik';
import { Col, FormGroup, Label, Row } from 'reactstrap'
import { rfidCardInitialValue, rfidCardValidation } from '../../../../Data/Application/ProjectList/ProjectList';
import { RfidCardInitialValue } from '../../../../Types/Application/ProjectList/ProjectList';
import ButtonSection from '../ProjectCreate/ButtonSection';
import Swal from 'sweetalert2';
import api from '../../../../utils/api';

const CreateNewRfidForm = () => {
    const navigate = useNavigate();
    const { createdFormData } = useAppSelector((state) => state.project);
    const dispatch = useAppDispatch();
  
    const projectSubmit = async (values: RfidCardInitialValue) => {
      const submittedData = {
        rfId: 0,
        rfidCardUniqueNumber: values.title,
        status: false
      };
      if (!submittedData.rfidCardUniqueNumber || submittedData.rfidCardUniqueNumber.trim() === "") {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please fill all the required fields.',
        });
        return; // Stop submission if validation fails
      }
      if (isNaN(Number(submittedData.rfidCardUniqueNumber)) || submittedData.rfidCardUniqueNumber.length !== 10) {
        Swal.fire({
          icon: 'error',
          title: 'Validation Error',
          text: 'RFID Card Number must be a 10 digit number.',
        });
        return; // Stop submission if validation fails
      }
      if(values.title.length === 10){
        dispatch(setCreatedData([...createdFormData, submittedData]));
        try {
          const response = await api.post('/api/RFIDCardMaster/AddRFIDCardMaster', submittedData, {
            headers: {
              'Content-Type': 'application/json',
            }
          });
      
          if (response.status === 200 || response.status === 201) {
            dispatch(setCreatedData([...createdFormData, response.data]));
      
            Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: 'RFID Card Created successfully.',
            }).then(() => {
              navigate(`${process.env.PUBLIC_URL}/rfidCard/rfidCardList`);
            });
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Unexpected Response',
              text: 'Please try again later.',
            });
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Submission Failed',
            text: 'Something went wrong while creating the RFID Card.',
          });
        }
      }else{
          Swal.fire({
            icon: 'error',
            title: 'Submission Failed',
            text: 'RFID Card Number must be 10 digit.',
          });
      }
      
    };
    return (
      <Formik initialValues={rfidCardInitialValue} validationSchema={rfidCardValidation} onSubmit={projectSubmit}>
        {() => (
          <Form className="theme-form">
            <Row>
                <Col sm="5">
                <FormGroup>
                    <Label check>RFID Card No. <span className='text-danger'>( RFID Card No. must be unique.)</span></Label>
                    <Field name="title" type="text" className="form-control" placeholder="Enter RFID Card 10 digit number here..." />
                    <ErrorMessage name="title" component="span" className="text-danger" />
                </FormGroup>
                </Col>
                <Col sm="4" className='mt-4'>
                    <ButtonSection cancel_url={`/rfidCard/rfidCardList`} />
                </Col>
            </Row>
            
          </Form>
        )}
      </Formik>
    )
}

export default CreateNewRfidForm